/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState, useMemo } from 'react';
import { DisablednessContext } from './Disabledness';

export namespace DisablednessProvider {
  export interface Props {}
}

export const DisablednessProvider: React.FC<DisablednessProvider.Props> = ({ children }) => {
  const [disabledness, setDisabledness] = useState<boolean>(false);
  const contextValue = useMemo<DisablednessContext>(
    () => ({
      disabled: disabledness,
      setDisabled: (isDisabled: boolean) => setDisabledness(isDisabled),
    }),
    [disabledness],
  );

  return <DisablednessContext.Provider value={contextValue}>{children}</DisablednessContext.Provider>;
};
